import React, { useState, useEffect } from 'react';
import {
  BackButton,
  ThinTextField,
  ThinDropdown,
  AddButton,
} from '../../common/GeneralComponent';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/partials/Loader';
import { fetchData } from '../../../utils/functions';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const AddFeatureSubType = () => {
  const [loader, setLoader] = useState(false);
  const [features, setFeatures] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetch features for dropdown
  const loadFeatures = async () => {
    try {
      const res = await fetchData("features", "GET", null, {}, {}, navigate, "", dispatch);
      setFeatures(res?.data || []);
    } catch (err) {
      toast.error("Failed to load features.");
    }
  };

  useEffect(() => {
    loadFeatures();
  }, []);

  const formik = useFormik({
    initialValues: {
      feature_sub_type: '',
      feature_id: '',
      status: 1,
    },
    validationSchema: Yup.object({
      feature_sub_type: Yup.string()
        .required('Sub Type name is required')
        .min(3, 'Must be at least 3 characters'),
      feature_id: Yup.number()
        .typeError('Feature selection is required')
        .required('Feature selection is required'),
      status: Yup.number()
        .required('Status is required')
        .oneOf([0, 1], 'Invalid status'),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        const response = await fetchData(
          "subtypes",
          "POST",
          values,
          {},
          {},
          navigate,
          "/subtypes",
          dispatch
        );
        toast.success(response.message || "Sub Type added");
        navigate("/subtypes");
      } catch (err) {
        toast.error(err.message || "Failed to add Sub Type");
      } finally {
        setLoader(false);
      }
    },
  });

  return (
    <div  className="w-full my-4 mx-auto">
      {loader && <Loader />}
      {/* <BackButton to="/subtypes" text="Back" />
      <h1 className="text-black text-[1.475rem] text-Black font-[Bold] ">
        Create Feature Sub Type
      </h1> */}

       <div className="flex  lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
                                        <h1 className="text-black text-[1.475rem] text-Black font-[Bold] ">
                                                  Create Feature Sub Type
                                                 </h1>
                                       <BackButton text="Back" to="/subtypes" />
                                             </div>
      <div  className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4  mb-[7rem]">
        <div  className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="lg:text-[0.875rem] text-[13px]  tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Create Feature Sub Type
          </h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="p-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 p-4 my-4">
            {/* Feature Sub Type Name */}
            <div className="py-[0.25rem]">
              <ThinTextField
                label="Sub Type Name"
                name="feature_sub_type"
                value={formik.values.feature_sub_type}
                onChange={formik.handleChange}
              />
              {formik.touched.feature_sub_type && formik.errors.feature_sub_type && (
                <p className="text-sm text-red-500 mt-1">
                  {formik.errors.feature_sub_type}
                </p>
              )}
            </div>

            {/* Feature Dropdown */}
            <div>
              <ThinDropdown
                label="Select Feature"
                name="feature_id"
                value={formik.values.feature_id}
                onChange={(e) =>
                  formik.setFieldValue('feature_id', e.target.value === '' ? '' : parseInt(e.target.value))
                }
                options={[
                  { value: '', label: 'Select Feature' },
                  ...features.map((feature) => ({
                    value: feature.feature_id,
                    label: `${feature.feature_name}`,
                  })),
                ]}
              />
              {formik.touched.feature_id && formik.errors.feature_id && (
                <p className="text-sm text-red-500 mt-1">{formik.errors.feature_id}</p>
              )}
            </div>

            

            {/* Status Dropdown */}
            <div>
              <ThinDropdown
                label="Status"
                name="status"
                value={formik.values.status}
                onChange={(e) =>
                  formik.setFieldValue('status', parseInt(e.target.value))
                }
                options={[
                  { value: 1, label: 'Active' },
                  { value: 0, label: 'Inactive' },
                ]}
              />
              {formik.touched.status && formik.errors.status && (
                <p className="text-sm text-red-500 mt-1">{formik.errors.status}</p>
              )}
            </div>
          </div>
          <div className='p-4'>
            <AddButton text="Submit" type="Submit" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFeatureSubType;
